import { BaseSyntheticEvent, FC, useEffect, useState } from 'react'
import { Button } from '../../../components/Button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Loading } from '../../../components/Loading/Loading'
import { GET, POST, PUT } from '../../../services/api'
import { i18n } from '../../../translate/i18n'
import { Input } from '../../../components/Input/Input'
import { BreadCrumbs } from '../../../components/BreadCrumbs/breadCrumbrs'
import Swal from 'sweetalert2'
import { isCnpjValid } from '../../../functions/document'
import uuid from 'react-uuid'
import useAuth from '../../../hooks/useAuth'
import { removeEspacosEmBranco, cpfToNumber } from '../../../utils/formater'
import { clearMask, cpfCnpjNoMask } from '../../../utils/utils'
import usePluginSpace from '../../../hooks/usePluginSpace'



type DataPhoneCustomerDto = {
  typePhone: 'principal' | 'secondary' | 'message' | 'cell' | 'landline';
  numberPhone: string;
}


type configField = {
  visible: boolean
  mandatory: boolean
  name: string,
  fieldName: string,
}

type AddressDataCustomerDto = {
  zipCode: string;
  street: string;
  number: string;
  extra: string;
  district: string;
  city: string;
  state?: string;
  reference: string;
  typeAddress: 'delivery' | 'payment' | 'main';
  ibge?: string;
  ibgeCode?: string;
}

type Form = {
  pluginspaceId: number;
  pluginconfigId?: number;
  name: string
  email: string;
  doc: string;
  password: string;
  addresses: [AddressDataCustomerDto];
  phones: [DataPhoneCustomerDto];
  type?: string;
  cpf: string;
  optinWhatsapp: boolean;
  preCreated: boolean;
  birthDate: Date | null;
  gender: string | null;
  lgpdDataAceiteCarta?: Date;
  inscEstadual?: string;
  customerCode?: number;
  idTerms?: number;
  tradeName?: string;
  comercialReference?: string;
  status?: 'active' | 'inactive' | 'blocked';
}




const CriarUsuariosContent: FC = () => {
  const navigate = useNavigate()
  const [image, setImage] = useState<File | null>(null)

  const [typeDoc, setTypeDoc] = useState<'cpf' | 'cnpj'>('cnpj') // Default to CNPJ for whole sellers

  const [loading, setLoading] = useState(false)
  const [isento, setIsento] = useState('false')
  const { getPluginSpace } = usePluginSpace()

  const [haveFieldConfig, setHaveFieldConfig] = useState(false)
  const [fieldsConfig, setFieldsConfig] = useState<configField[]>([])
  const [customerGroups, setCustomersGroups] = useState<{ id: string, name: string }[]>([])
  const [customerGroup, setCustomerGroup] = useState<number>(-1)

  const [form, setForm] = useState<Form>({
    pluginspaceId: 0,
    password: '',
    name: '',
    email: '',
    doc: '',
    addresses: [{
      zipCode: '',
      street: '',
      number: '',
      extra: '',
      district: '',
      city: '',
      state: '',
      reference: '',
      typeAddress: 'main',
    }],
    phones: [{
      typePhone: 'principal',
      numberPhone: '',
    }],
    cpf: '',
    optinWhatsapp: false,
    birthDate:null,
    gender:null,
    lgpdDataAceiteCarta: new Date(),
    preCreated: true,
    status: 'active',
  })

  const getCEP = async (value: string) => {
    value = value.replace(/[^\d]/g, '')
    if (value && value.length === 8) {
      try {
        setLoading(true)
        const res = await GET(`https://viacep.com.br/ws/${value}/json/`)
        setForm({
          ...form,
          addresses: [{
            ...form.addresses[0],
            street: res.logradouro,
            district: res.bairro,
            city: res.localidade,
            state: res.uf,
            extra: '',
            number: '',
          }],
        })
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    }
  }

  const validateForm = () => {
    const errors: string[] = [];

    let needToVerify = {
      email: true,
      telephone: true,
      tradeName: true,
      comercialReference: true,
      gender: true,
      birth: true,
    }

    if (haveFieldConfig && fieldsConfig) {
      const emailField = fieldsConfig.find((field: configField) => field.name === 'email')
      const nomefantasiaField = fieldsConfig.find((field: configField) => field.name === 'nomefantasia' || field.name === 'ReferênciaComercial')
      const referênciacomercialField = fieldsConfig.find((field: configField) => field.name === 'referênciacomercial' || field.name === 'NomeFantasia')
      const phoneField = fieldsConfig.find((field: configField) => field.name === 'telefone')
      const genderField = fieldsConfig.find((field: configField) => field.name === 'telefone')
      const birthField = fieldsConfig.find((field: configField) => field.name === 'telefone')


      needToVerify.email = (emailField && emailField.mandatory === true && emailField.visible === true) ? true : false

      needToVerify.birth = (genderField && genderField.mandatory === true && genderField.visible === true)
        && typeDoc === 'cpf' ? true : false

      needToVerify.gender = (birthField && birthField.mandatory === true && birthField.visible === true)
        && typeDoc === 'cpf' ? true : false


      needToVerify.telephone = (phoneField && phoneField.mandatory === true && phoneField.visible === true) ? true : false

      needToVerify.tradeName = (nomefantasiaField && nomefantasiaField.mandatory === true && nomefantasiaField.visible === true)
        && typeDoc === 'cnpj' ? true : false

      needToVerify.comercialReference = (referênciacomercialField
        && referênciacomercialField.mandatory === true
        && referênciacomercialField.visible === true)
        && typeDoc === 'cnpj' ? true : false
    }



    if (!form.name) errors.push(typeDoc === 'cpf' ? 'Nome' : 'Razão Social');

    if (!form.doc || !form.cpf || (form.cpf.includes('_') || form.doc.includes('_'))) errors.push(typeDoc === 'cpf' ? 'CPF' : 'CNPJ');
    if (!form.addresses[0].zipCode) errors.push('CEP');
    if (!form.addresses[0].street) errors.push('Logradouro');
    if (!form.addresses[0].number) errors.push('Número');
    if (!form.addresses[0].district) errors.push('Bairro');
    if (!form.addresses[0].city) errors.push('Cidade');
    if (!form.addresses[0].state) errors.push('Estado');


    if ((!form.phones[0].numberPhone || form.phones[0].numberPhone.includes('_')) && needToVerify.telephone) errors.push('Telefone');
    if (!form.email && needToVerify.email) errors.push('Email');


    if (!form.comercialReference && needToVerify.comercialReference) errors.push('Referência Comercial');
    if (!form.tradeName && needToVerify.tradeName) errors.push('Nome Fantasia');

    if (!form.birthDate && needToVerify.birth && typeDoc === 'cpf') errors.push('Data de nascimento');
    if (!form.gender && needToVerify.gender && typeDoc === 'cpf') errors.push('Gênero');
    if (!form.lgpdDataAceiteCarta) errors.push('Data de aceite da LGPFD');

    return errors;
  };

  const createUser = async () => {
    try {
      const errors = validateForm();
      if (errors.length > 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atençao',
          text: `Os campos a seguir estão vazios ou inválidos: ${errors.join(', ')}`,
        });
        return;
      }

      const customerToSend: Form = {
        ...form,
        doc: cpfCnpjNoMask(form.doc),
        cpf: cpfCnpjNoMask(form.doc),
        phones: [{ ...form.phones[0], numberPhone: clearMask(form.phones[0].numberPhone) }]
      }

      setLoading(true);
      const response = await POST('/customer/whole_saler', customerToSend);

      if (!response || !response.success) {
        setLoading(false);

        Swal.fire({
          icon: 'warning',
          title: 'Atenção',
          text: response.message,
        });
        return;
      }

      const customerId = response.dados.id;
      // Upload image if exists

      const pluginspace = await getPluginSpace()

      if (image && image !== undefined && customerId) {
        const formData = new FormData();
        formData.append('file', image)
        formData.append('name', `${pluginspace.subdomain}/customer_images/customer_${customerId.toString()}.jpg`)
        const uploadResponse = await POST('/upload-images/upload-customer', formData)
        if (!uploadResponse || !uploadResponse.success) {
          setLoading(false)
          Swal.fire({
            title: 'Atenção',
            text: 'Imagem não foi criada com sucesso.',
            icon: 'warning'
          })
          return
        }

      }

      const data = {
        data: [
          {
            customerId: customerId,
            groupId: parseInt(customerGroup.toString())
          }
        ]
      }
      await POST('/customer_groups/vinculate_customer', data)




      Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: 'Cliente cadastrado com sucesso!',
      }).then(() => navigate('/customer/report'));

    } catch (e: any) {
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Erro ao cadastrar cliente!',
      });
    }
  };
  const generatePassword = (len: number) => {
    var pwd = [],
      cc = String.fromCharCode,
      R = Math.random,
      rnd,
      i
    pwd.push(cc(48 + (0 | (R() * 10)))) // push a number
    pwd.push(cc(65 + (0 | (R() * 26)))) // push an upper case letter
    for (i = 2; i < len; i++) {
      rnd = 0 | (R() * 62) // generate upper OR lower OR number
      pwd.push(cc(48 + rnd + (rnd > 9 ? 7 : 0) + (rnd > 35 ? 6 : 0)))
    }
    // shuffle letters in password
    setForm({
      ...form, password: pwd
        .sort(function () {
          return R() - 0.5
        })
        .join('')
    })
  }

  async function getCustomersGroups() {
    try {
      const res = await GET('/customer_groups')
      const groups = res.data.map((row: any) => {
        return {
          id: row.id,
          name: row.name,
        }
      })
      setCustomersGroups([{ id: -1, name: 'Sem grupo' }, ...groups])
    } catch (error) {
      console.log(error)
    }
  }

  async function getFieldConfig() {
    try {
      setLoading(true)
      await  getCustomersGroups()
      const fieldConfig = await GET('/fieldconfig')


      setHaveFieldConfig(fieldConfig ? true : false)

      if (fieldConfig) {
        const data: configField[] = []
        const regexPattern = new RegExp("true");

        Object.entries(fieldConfig.data[0].content).map((fieldConfig: any) => {
          data.push({
            visible: regexPattern.test(fieldConfig[1].visible),
            name: fieldConfig[0],
            fieldName: fieldConfig[1].name,
            mandatory: regexPattern.test(fieldConfig[1].mandatory),
          })
        })
        setFieldsConfig(data)
      }

      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }


  useEffect(() => {
    getFieldConfig()

  }, [])


  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='d-flex justify-content-between flex-wrap gap-5'>
            <div style={{ flex: 1 }}>
              <div className='w-100 card'>

                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>{i18n.t(`customer_list.create`)}</span>
                    <BreadCrumbs />
                  </h3>
                </div>
                <div className='px-10 py-5'>

                  <div className='d-flex gap-4 '>


                    <Input
                      inputAttr={{
                        type: 'newRadioModal',
                        name: 'typeDoc',
                      }}
                      placeholder={'CPF'}
                      label={'CPF'}
                      value={'cpf'}
                      checked={typeDoc === 'cpf'}
                      name='typeDoc'
                      change={(value: string) => {
                        setTypeDoc('cpf')
                        setForm({ ...form, doc: '', cpf: '' })
                      }}
                    />
                    <Input
                      inputAttr={{
                        type: 'newRadioModal',
                        name: 'typeDoc',
                      }}
                      placeholder={'CNPJ'}
                      label={'CNPJ'}
                      value={'cpnj'}
                      checked={typeDoc === 'cnpj'}
                      name='typeDoc'
                      change={(value: string) => {
                        setTypeDoc('cnpj')
                        setForm({ ...form, doc: '', cpf: '' })
                      }}
                    />
                  </div>


                  <Input
                    inputAttr={{
                      type: typeDoc,
                    }}
                    placeholder={typeDoc.toUpperCase()}
                    label={typeDoc.toUpperCase()}
                    value={form.doc || ''}
                    change={(value: any) => setForm({ ...form, doc: value, cpf: value })}
                  />

                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`${typeDoc === 'cpf' ? 'account.customer_name' : 'account.corporate_name'}`)}
                    label={i18n.t(`${typeDoc === 'cpf' ? 'account.customer_name' : 'account.corporate_name'}`)}
                    value={form.name || ''}
                    change={(value: any) => setForm({ ...form, name: value })}
                  />

                  <Input
                    inputAttr={{
                      type: 'select',
                    }}

                    options={customerGroups.map((group) => ({
                      select: group.name,
                      value: group.id,
                    }))}
                    label={'Grupo do Cliente'}
                    value={customerGroup}
                    change={(value: any) => setCustomerGroup(value)}
                  />
                  <div className='flex-grow-1'>
                    {((haveFieldConfig && fieldsConfig.find((field) => field.name === 'email' && field.visible)) || !haveFieldConfig) && (
                      <Input
                        inputAttr={{
                          type: 'email',
                        }}
                        placeholder='Email'
                        label={
                          (haveFieldConfig && fieldsConfig.find((field) => field.name === 'email' && field.fieldName)) ?
                            fieldsConfig.find((field) => field.name === 'email' && field.fieldName)?.fieldName :
                            "Email"
                        }
                        value={form.email || ''}
                        change={(value: any) => setForm({ ...form, email: value })}
                      />
                    )}
                    <div className='flex-grow-1 d-flex justify-content-between align-items-end gap-4'>
                      <Input
                        inputAttr={{
                          type: 'password',
                        }}
                        placeholder={i18n.t(`user.password`)}
                        label={i18n.t(`user.password`)}
                        autoComplete='new-password'
                        value={form.password || ''}
                        change={(value: any) => setForm({ ...form, password: value })}
                      />

                      <Button
                        text={i18n.t(`user.generate_pass`)}
                        color='primary'
                        size='small'
                        btnAttr={{
                          type: 'button',
                        }}
                        click={() => generatePassword(8)}
                        btnClass='fw-normal w-90px fs-8 mt-2 px-0'
                      />

                    </div>
                  </div>
                  {((haveFieldConfig && fieldsConfig.find((field) => (field.name === 'nomefantasia'
                    || field.name === 'NomeFantasia'
                    || field.name === 'nomeFantasia'
                  ) && field.visible)) || !haveFieldConfig) && typeDoc !== 'cpf' && (
                      <Input
                        label="Nome Fantasia:"
                        placeholder="Nome Fantasia:"
                        value={form.tradeName || ''}
                        inputAttr={{ type: "text" }}
                        change={(value: any) => setForm({ ...form, tradeName: value })}
                      />
                    )}
                  {((haveFieldConfig && fieldsConfig.find((field) => (field.name === 'referênciacomercial'
                    || field.name === 'ReferênciaComercial'
                    || field.name === 'referênciaComercial'
                  ) && field.visible)) || !haveFieldConfig) && typeDoc !== 'cpf' && (
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={'Referência Comercial'}
                        label={'Referência Comercial'}
                        value={form.comercialReference || ''}
                        change={(value: any) => setForm({ ...form, comercialReference: value })}
                      />
                    )}
                  {((haveFieldConfig && fieldsConfig.find((field) => field.name === 'telefone' && field.visible)) || !haveFieldConfig) && (
                    <Input
                      inputAttr={{
                        type: 'tel',
                      }}
                      placeholder='Telefone'
                      label='Telefone'
                      value={form.phones[0].numberPhone || ''}
                      change={(value: any) => setForm({
                        ...form,
                        phones: [{ ...form.phones[0], numberPhone: value }]
                      })}
                    />
                  )}

                  {typeDoc !== 'cpf' && (<>
                    <Input
                      label="Isento:"
                      placeholder="Isento:"
                      inputAttr={{ type: "select" }}
                      value={isento}
                      change={(value: string) => {
                        setIsento(value.toLowerCase());
                      }}
                      options={[
                        {
                          select: 'Sim',
                          value: 'true'
                        },
                        {
                          select: 'Não',
                          value: 'false'
                        }
                      ]}
                    />
                    {isento !== 'true' && (
                      <Input
                        label="Inscrição Estadual:"
                        placeholder="Inscrição Estadual:"
                        value={form.inscEstadual || ''}
                        inputAttr={{ type: "text" }}
                        change={(value: any) => setForm({ ...form, inscEstadual: value })}
                      />
                    )}
                  </>)}

                  {typeDoc === 'cpf' && (<>

                    {((haveFieldConfig && fieldsConfig.find((field) => field.name === 'dataNascimento' && field.visible))
                      || !haveFieldConfig) && typeDoc === 'cpf' && (
                        <Input
                          label="Data Nascimento"
                          placeholder="Data Nascimento"
                          inputAttr={{ type: "date" }}
                          value={form.birthDate ? new Date(form.birthDate).toISOString().substring(0, 10) : ''}
                          change={(value: string) => {
                            setForm({ ...form, birthDate: new Date(value) })
                          }
                          }

                        />
                      )}
                    {((haveFieldConfig && fieldsConfig.find((field) => field.name === 'genero' && field.visible))
                      || !haveFieldConfig) && typeDoc === 'cpf' && (
                        <Input
                          label="Gênero"
                          placeholder="Gênero"
                          value={form.gender || ''}
                          inputAttr={{ type: "select" }}
                          options={[
                            { select: 'Masculino', value: 'masculino' },
                            { select: 'Feminino', value: 'feminino' },
                            { select: 'Não informar', value: 'none' },
                          ]
                          }
                          change={(value: any) => setForm({ ...form, gender: value })}
                        />
                      )}


                  </>)}

                </div>
              </div>
            </div>
            <div className='justify-content-between' style={{ flex: 1 }}>
              <div className='w-100 card ms-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>
                      Imagem do Cliente
                    </span>
                  </h3>
                </div>
                <div className='px-10 py-5 d-flex gap-5'>
                  <div className=''>
                    <Input
                      inputAttr={{
                        type: 'image',
                      }}
                      value={image}
                      change={(value: BaseSyntheticEvent) =>
                        setImage(value ? value.target.files[0] : null)
                      }
                    />
                  </div>

                </div>
              </div>
              <br />

              <div className='w-100 card ms-5'>
                <div className='card-header py-5'>
                  <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-4 mb-1'>{i18n.t(`account.address`)}</span>
                  </h3>
                </div>
                <div className='px-10 py-5'>
                  <div className='d-flex justify-content-between'>
                    <div className='me-3 flex-grow-1'>
                      <Input
                        inputAttr={{
                          type: 'cep',
                        }}
                        placeholder={i18n.t(`account.zip_code`)}
                        label={i18n.t(`account.zip_code`)}
                        value={form.addresses[0].zipCode || ''}
                        change={(value: any) => setForm({
                          ...form,
                          addresses: [{ ...form.addresses[0], zipCode: value }]
                        })}
                        blur={(value: string) => getCEP(value)}
                      />
                    </div>
                    <Input
                      inputAttr={{
                        type: 'default',
                      }}
                      placeholder={i18n.t(`account.public_place`)}
                      label={i18n.t(`account.public_place`)}
                      value={form.addresses[0].street || ''}
                      change={(value: any) =>
                        setForm({ ...form, addresses: [{ ...form.addresses[0], street: value }] })
                      }
                    />
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div className='me-3 flex-grow-1'>
                      <Input
                        inputAttr={{
                          type: 'default',
                        }}
                        placeholder={i18n.t(`account.number`)}
                        label={i18n.t(`account.number`)}
                        minNumber={0}
                        value={form.addresses[0].number || ''}
                        change={(value: any) =>
                          setForm({ ...form, addresses: [{ ...form.addresses[0], number: value }] })
                        }
                      />
                    </div>
                    <Input
                      inputAttr={{
                        type: 'default',
                      }}
                      placeholder={i18n.t(`account.address_complement`)}
                      label={i18n.t(`account.address_complement`)}
                      value={form.addresses[0].extra || ''}
                      change={(value: any) =>
                        setForm({ ...form, addresses: [{ ...form.addresses[0], extra: value }] })
                      }
                    />
                  </div>
                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`account.neighbourhood`)}
                    label={i18n.t(`account.neighbourhood`)}
                    value={form.addresses[0].district || ''}
                    change={(value: any) =>
                      setForm({ ...form, addresses: [{ ...form.addresses[0], extra: value }] })
                    }
                  />
                  <div className='d-flex justify-content-between gap-4'>
                    <Input
                      inputAttr={{
                        type: 'default',
                      }}
                      placeholder={i18n.t(`account.city`)}
                      label={i18n.t(`account.city`)}
                      value={form.addresses[0].city || ''}
                      change={(value: any) =>
                        setForm({ ...form, addresses: [{ ...form.addresses[0], city: value }] })
                      }
                    />
                    <Input
                      inputAttr={{
                        type: 'default',
                      }}
                      placeholder={i18n.t(`account.state`)}
                      label={i18n.t(`account.state`)}
                      value={form.addresses[0].state || ''}
                      change={(value: any) =>
                        setForm({ ...form, addresses: [{ ...form.addresses[0], state: value }] })
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className='row'>
            <div className='d-flex w-100'>
              <div className='col-6 d-flex justify-content-start'>
                <Button
                  text={i18n.t(`buttons.back`)}
                  color='info'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate(-1)}
                  btnClass='fw-bolder m-9'
                />
              </div>
              <div className='col-6  d-flex justify-content-end'>
                <Button
                  text={i18n.t(`buttons.save`)}
                  color='primary'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={createUser}
                  btnClass='fw-bolder m-9'
                />
              </div>
            </div>
          </div>
        </div>

      )}
    </>
  )
}

const CriarCustomer: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          { title: 'Dashboard', path: 'dashboard', isActive: true },
          { title: i18n.t(`customer_list.customer_list`), path: 'customer/report', isActive: true },
          { title: i18n.t(`buttons.create`), path: 'customer/create', isActive: true },
        ]}
      >
        {i18n.t(`customer_list.create`)}
      </PageTitle>
      <CriarUsuariosContent />
    </>
  )
}

export { CriarCustomer }
